(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("NewsletterComponent");

  Components.create('NewsletterComponent', {

    Selectors: {
      Container: '#newsletter-container',
      Content: '.dynamic-content',
      FirstStep: '#newsletter-container .first-step-box',
      RegisterStep: '#newsletter-container .register-step-box',
	  Form: '#newsletterComponentForm',
	  FormContainer: '.subscribe-step-box',
	  Category: '#category',
	  Email: '#newsletter-container #nl-email',
	  Yes: '#newsletter-container .newsletter-yes',
      No: '#newsletter-container .newsletter-no',
      RegisterCard: '#newsletter-container .nl-register-card',
      UnsubscribeLink: '.unsubscribe-link',
      UnsubscribeBox: '.unsubscribe-step-box',
      UnsubscribeForm: '#newsletterUnsubscribeForm',
      UnsubscribeEmail: '#newsletter-container #nl-unsubscribe-email',
      UnsubscribeMsg: '.newsletter-unsubscribe-msg',
      UnsubscribeContent: '.unsubscribe-dynamic-content',
      IconMail: '.icon-mail'
	},
	
	show: function() {
	  $(this.Selectors.FormContainer).hide();
	  $(this.Selectors.RegisterStep).hide();
	  $(this.Selectors.UnsubscribeBox).hide();
	},
	
	noCard: function() {
	  var _this = this;
	  $(_this.Selectors.No).on('click', function (e) {
		  e.preventDefault();
		  $(_this.Selectors.IconMail).hide();
		  $(_this.Selectors.FormContainer).show();
		  $(_this.Selectors.FirstStep).hide();
		  _this.manageSubmit();
	  });
	},
	
	gotCard: function() {
	  var _this = this;
	  $(_this.Selectors.Yes).on('click', function (e) {
		  e.preventDefault();
		  $(_this.Selectors.IconMail).hide();
		  $(_this.Selectors.RegisterStep).show();
		  $(_this.Selectors.FirstStep).hide();
		  _this.registerCard();
	  });
	},
	
	registerCard: function() {
	  var _this = this;
	  $(_this.Selectors.RegisterCard).on('click', function (e) {
		e.preventDefault();
		window.location.replace('/login');
	  });	
	},
	
	unsubscribe: function() {
	  var _this = this;
	  
	  $(_this.Selectors.UnsubscribeLink).on('click', function (e) {
		e.preventDefault();
		$(_this.Selectors.UnsubscribeBox).show();
		$(_this.Selectors.FirstStep).hide();
		$(_this.Selectors.UnsubscribeMsg).hide();
	  });
	  
	  $(_this.Selectors.UnsubscribeBox).on('submit', '#newsletterUnsubscribeForm', {}, function (e) {
		e.preventDefault();  
		
		var url = $(_this.Selectors.UnsubscribeForm).attr('action');
    	var email = $(_this.Selectors.UnsubscribeEmail).val();
    	
    	var ajaxData = {
    	  email: email
	    };
    	
    	axios.post(url, ajaxData)
	      .then(function (response) {
	    	var validated = $(response.data).find('.unsubscribe-dynamic-content').prevObject[0].dataset.validated;
	    	if(validated == 'true') {
	    	  $(_this.Selectors.UnsubscribeMsg).show();
	    	  $(_this.Selectors.UnsubscribeForm).hide();
		    }else{
		      $(_this.Selectors.UnsubscribeContent).replaceWith(response.data);
		      $(_this.Selectors.UnsubscribeMsg).hide();
		    }
	      })
	      .catch(function (error) {
	        logger.d("Couldn't render newsletter component: ", error);
	      })
    	
	  });
	},
	
    manageSubmit: function() {
      var _this = this;
      $(_this.Selectors.Container).on('submit', '#newsletterComponentForm', {}, function (e) {
    	e.preventDefault();
    	
    	var url = $(_this.Selectors.Form).attr('action');
    	var category = $(_this.Selectors.Category).find('option:selected').val();
    	var email = $(_this.Selectors.Email).val();
    	
	    var ajaxData = {
    	  category: category,
    	  email: email
	    };
	    
	    axios.post(url, ajaxData)
	      .then(function (response) {
	    	var $red = $(response.data).find('#redirect').prevObject[0];
	    	var redUrl = ($red != null) ? $red.dataset.redirect : null;
	    	if(redUrl != null) {
//		      window.location.replace(redUrl + '?category=' + category + '&email=' + email);
		      window.location.replace(redUrl);
		    }
	        $(_this.Selectors.Content).replaceWith(response.data);
	      })
	      .catch(function (error) {
	        logger.d("Couldn't render newsletter component: ", error);
	      })
      });
    },

    init: function() {
      this.show();
      this.noCard();
      this.gotCard();
      this.unsubscribe();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
